/**
 * @deprecated please use @website/ui instead
 */
export * from "./loading";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./loading.types";
